module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_4.8d580a23.png";